module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.2d76e4a5.mp3";